import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CFormSelect,
  CButton,
  CImage,
  CRow,
  CLink
} from '@coreui/react';
import { BsEyeFill,BsEyeSlashFill } from "react-icons/bs";
import CIcon from '@coreui/icons-react'
import { MyButton } from '../components/index'
import { UFunc } from '../helpers/functions'
import { isMobile } from "react-device-detect";

const pjson = require('../../package.json');
const Login = (props) => {
	const {
		setToken,setLoading, showToast,setSessionaktif,
	} = props; 

	//console.log("Login - props => "+JSON.stringify(props));
	const uNavigate  		= useNavigate();
	const uDispatch			= useDispatch();
	const uBahasaob  		= useSelector(state => state.listBahasa);
	const uRouteProfileArr	= useSelector(state => state.profileRoute); 
	const uBranchcode		= useSelector(state => state.branchCode); 

	const uTokenObj			= JSON.parse(localStorage.getItem("token")||"{}");
	const [uDatacabangArr,setDatacabangArr]	= React.useState(JSON.parse(localStorage.getItem("cabanglist") || "[]"));
	const [uInpUsername,setUsername]  		= React.useState(localStorage.getItem("lastusername") || "");
	const [uInpPasswd,setInpPasswd]   		= React.useState('');
	const [uISPasswordshow,setPasswordshow]	= React.useState(false);
	const [uBtnDisabled,setBtnDisabled]		= React.useState(true);
	const uGeolocationObj					= JSON.parse(useSelector(state => state.geolocation_str) || "{}");
	const [uErrorlocation,setErrorlocation]		= React.useState();
	const [uTokentosend,setTokentosend]			= React.useState();

	const initBrandname	= () =>{
		const vIcon = (
			<CImage
				src={"images/logo192.png"}
				className="me-1 d-md-none" height={40}/>
		)

		const vNameArr = pjson.name;
		return (
			<>
			{vIcon}
			<span className="classtitlelogin align-middle" style={{}}>
				{vNameArr}
			</span>
			<small className="ms-2">v{pjson.version}</small>
			</>
		)//>
	}

	const hdlKlikLogin = () => {
		//---VALIDASI--/
		if(uInpUsername.trim() === "" || uInpPasswd === "") return;
		//---END VALIDASI--/

		//--GEOLOCATION_DULU--/
		if (navigator.geolocation) {
			setLoading(true);
			setBtnDisabled(true);
			navigator.geolocation.getCurrentPosition((position) => {
				setLoading(false);
				setBtnDisabled(false);
				const watchID = navigator.geolocation.watchPosition(()=>{}, ()=>{});

				const vTmpObj = {
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,  
					watchID: watchID,
				}
				apiProseslogin(JSON.stringify(vTmpObj));
			},
			// Error callback: sets an error message based on the error code
			(err) => {
				setLoading(false);
				setBtnDisabled(false);

				let vErrortmp;
				switch (err.code) {
					case err.PERMISSION_DENIED:
						vErrortmp	= ('User denied the request for Geolocation.');
						break;
					case err.POSITION_UNAVAILABLE:
						vErrortmp	= ('Location information is unavailable.');
						break;
					case err.TIMEOUT:
						vErrortmp	= ('The request to get user location timed out.');
						break;
					case err.UNKNOWN_ERROR:
						vErrortmp	= ('An unknown error occurred.');
						break;
					default:
						vErrortmp	= ('An unexpected error occurred.');
				}
				// Log the error message for better debugging, or the error object if message is not available
				console.error("Geolocation Error:", err.message || err);
				setErrorlocation("NOTE Lokasi: "+vErrortmp);
				apiProseslogin();
			},
			// Options for getCurrentPosition
			{
				enableHighAccuracy: true, // Request the most accurate position possible
				timeout: 5000,            // Maximum time (ms) to wait for a position
				maximumAge: 0             // Don't use a cached position
			});
		} else {
			// Browser does not support Geolocation
			//localStorage.removeItem("geolocation_str");
			//showToast('Geolocation is not supported by your browser.');
			setErrorlocation("NOTE Lokasi: Geolocation is not supported by your browser.");

			apiProseslogin();
		}
		//--END GEOLOCATION_DULU--/
	}

	const apiProseslogin = (_GEOLOCATIONSTR) => {
		const vGeolocationObj = JSON.parse(_GEOLOCATIONSTR || "{}"); 
		
		setLoading(true);
		setBtnDisabled(true);
		localStorage.removeItem("routeslist");

		/*//--TEST_FRONTEND--/
		let vTimeout = setTimeout(()=>{ 
			clearTimeout(vTimeout); 
			setLoading(false);
			setBtnDisabled(false);

			alert(JSON.stringify(vGeolocationObj));
		},2000); return;
		//--END TEST_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_username : uInpUsername,
			send_passwd : uInpPasswd,
			send_geolocation: JSON.stringify(vGeolocationObj),
			send_tokenauth : uInpPasswd,
		});
		const vURLs	= pjson.homepage+"api2/api_login/pr_login";
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		})
		.then((response)=> { if (response.status === 200) return response.json(); })
		.then((output_string) => {
			setLoading(false);
			setBtnDisabled(false);

			if(output_string.langs) {
				uDispatch({type: "set", listBahasa: JSON.parse(output_string.langs || "{}")});
			}//-*/
			console.log("(Login - apiProseslogin) output_string",output_string);

			if(output_string.sukses) {
				setBtnDisabled(true);

				uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||"{}")});
				if(output_string.nav) {
					uDispatch({type: "set", listNav: JSON.parse(output_string.nav||"[]")});
				}//-*/

				uDispatch({type: "set", gIsEOMExecuted: ((output_string.status_eom||"YA")==="YA" ? true : false)});
				uDispatch({type: "set", gEOMLabel: (output_string.status_eom_label||"") });
				if(output_string.kasobject) {
					localStorage.setItem("kasgllist",output_string.kasobject);
				}
				localStorage.setItem("layananlist", (output_string.layananlist||"[]"));
				 
				localStorage.setItem("lastusername",(uInpUsername||"").trim());

				if(output_string.routes) {
					const vRouteLoadArr = JSON.parse(output_string.routes||"[]");
					const vNewRoutes	= [...uRouteProfileArr,...vRouteLoadArr];

					localStorage.setItem("routeslist", JSON.stringify(vNewRoutes));
					
					uDispatch({type: "set", gRouteISrefresh: true});
				}//-*/

				uDispatch({type: "set", geolocation_str: JSON.stringify(vGeolocationObj)});

				//--SECURITY_WARNING--/
				if(uInpUsername.trim() === uInpPasswd) {
					showToast("<p class='fw-bolder'>PERINGATAN KEAMANAN:</p>"+
						"<p>USERNAME dan PASSWORD Anda Terdeteksi <b>TIDAK AMAN</b>. Mohon Ganti Password Atau Username Anda !</p>"+
						"<p>Kondisi Tersebut Membuat DATA Rentan Terhadap <b>Serangan Hacker</b>.</p>"+
					"","ERROR");
				}
				//--END SECURITY_WARNING--*/

				setTokentosend(JSON.parse(output_string.token||"{}"));
			} else {
				vGeolocationObj.watchID && (navigator.geolocation.clearWatch(vGeolocationObj.watchID));

				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Login - apiProseslogin) output_string.errors : "+output_string.errors);
					const vMsg 	= (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {}
			}
		})
		.catch((error) =>{
			console.log("(Login - apiProseslogin) catch-error: "+error);
			setLoading(false);
			vGeolocationObj.watchID && (navigator.geolocation.clearWatch(vGeolocationObj.watchID));
			//uNavigate("/error500");
			setBtnDisabled(false);

			showToast(error,"ERROR");
		});
	}

	React.useEffect(() => {
		let vElfocus = document.getElementById("inpusername")
		if(uInpUsername.trim() !== "")
			vElfocus = document.getElementById("inppasswd")

		if(!isMobile) {
			vElfocus && vElfocus.focus()
		}

		return ()=>{
			setPasswordshow(false); 
			setErrorlocation();setTokentosend();
		}
	},[])
	React.useEffect(() => {
		setBtnDisabled(true);
		if(uInpUsername.trim() !== "" 
			&& uInpPasswd !== "") setBtnDisabled(false);
	},[uInpUsername,uInpPasswd])
	React.useEffect(() => {
		if(!uTokentosend) return;
		uDispatch({type: "set", locationError: uErrorlocation});
		setErrorlocation();

		setTokentosend();
		setToken(uTokentosend);
	},[uTokentosend]);

	if(!UFunc.isEmpty(uTokenObj)) { window.location.replace("/"); return (<></>); }

	return (
		<>
		<div className="classbglogintop" style={{
			backgroundImage:"url(images/bg_gradient_bottom.png)"
			}}/>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
			<div className="body flex-grow-1 px-3 d-flex align-items-center">
			<CRow className="justify-content-center w-100 mx-auto">
			<CCol md="3" xs="11" className="d-none d-md-flex flex-row align-items-center">
				<div align="center">
				<CImage src={"images/logo192.png"} height="175" className="m-auto " />
				</div>
			</CCol>
			<CCol md="1" lg="0" className="border-end"></CCol>
			<CCol md="5" xs="11" className="px-sm-2 px-lg-5 text-center">
			<div className="" style={{paddingBottom:"0"}}>
				{initBrandname()}
			</div>
			<div className="classfontsmaller">
				{UFunc.renderHTML(uBahasaob.petunjuk_login || "Silahkan Login untuk Masuk dan<br />Menggunakan Aplikasi Ini")}
			</div>

			<CForm className="px-md-4 px-lg-5">
				<CInputGroup className="my-2">
					<CInputGroupText>
					<CIcon icon="cilUser" className="text-danger"/>
					</CInputGroupText>
					<CFormInput type="text" 
						onChange={(e)=>setUsername(e.target.value)} 
						placeholder={(uBahasaob.word_username||"Username")+".."} 
						autoComplete="off" 
						value={uInpUsername}
						id="inpusername"
						className="bg-white"
						required/>
				</CInputGroup>

				<CInputGroup className="my-2">
					<CInputGroupText>
					<CIcon icon="cilLockLocked" className="text-danger"/>
					</CInputGroupText>

					<CFormInput type={uISPasswordshow ? "text" : "password"}
						onChange={(e)=>{setInpPasswd(e.target.value);}} 
						placeholder={(uBahasaob.word_passwd||"Password")+".."} 
						className={uISPasswordshow ? "fst-italic text-secondary" : ""}
						autoComplete="current-password" required
						id="inppasswd"/>

					{uInpPasswd!=="" && (
					<CInputGroupText className="bg-transparent px-2">
					<CLink onClick={()=>setPasswordshow(!uISPasswordshow)} className="classcursorpointer text-dark">
						{uISPasswordshow ? (<BsEyeFill/>) : (<BsEyeSlashFill/>)}
					</CLink>
					</CInputGroupText>
					)}
				</CInputGroup>

				<CInputGroup className="my-2 my-md-4">
				<MyButton
					iconname="cilLockUnlocked"
					onClick={()=>hdlKlikLogin()}
					disabled={uBtnDisabled}
					id="btnLogin">L o g i n</MyButton>
				</CInputGroup>
				<div className="text-center">
					<p className="classpetunjuk">
					{uBahasaob.caption_lupapasswd||"Lupa Password"}?{" "}
					<strong className="text-dark">{uBahasaob.caption_hubsupervisor||"Hubungi Supervisor"}</strong>
					</p>
				</div>
			</CForm>
			</CCol>
			</CRow>
			</div>
		</div>	
		</>
	)//>
}

export default Login